import React from 'react'

const MenuIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 21 21"><g fill="currentColor" fill-rule="evenodd"><circle cx="10.5" cy="10.5" r="1" /><circle cx="5.5" cy="10.5" r="1" /><circle cx="15.5" cy="10.5" r="1" /></g></svg>
    )
}

export default MenuIcon